// extracted by mini-css-extract-plugin
export var container = "styles-module--container--d4423";
export var header = "styles-module--header--c657b";
export var media = "styles-module--media--8e57c";
export var text = "styles-module--text--26dfe";